module.exports = __webpack_public_path__ + "assets/img/7773-af.svg";